import { ClickAwayListener, FormControl, Popper, makeStyles } from '@material-ui/core'
// import { Grid, IconButton, type DropdownSelectOption } from '@paintscout/ui'
import ColumnsIcon from '@material-ui/icons/ViewColumn'
import React, { useState } from 'react'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import type { User } from '@paintscout/api'
import type { QuoteTag } from 'paintscout'
import type { Moment } from 'moment'
import DropdownSelectMenuItem from '../DropdownSelect/DropdownSelectMenuItem'
import DropdownSelectFooter from '../DropdownSelect/DropdownSelectFooter'
import Grid from '../Grid'
import type { DropdownSelectOption } from '../DropdownSelect'
import IconButton from '../IconButton'

const useStyles = makeStyles((theme) => ({
  popper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[4],
    width: '250px',
    marginRight: theme.spacing(1)
  },
  container: {
    padding: theme.spacing(1, 2),
    maxHeight: '400px',
    overflowY: 'scroll'
  },
  button: {
    color: 'white',
    margin: 'auto 0'
  }
}))

//TODO: put this in one place
export interface QuoteRow {
  _id: string
  _rev: string
  invoice: boolean
  number: number
  client: string
  estimator: string
  archived: boolean
  isAssigned: boolean
  isOwner: boolean
  status: string
  location: React.ReactNode
  quote_date: number
  value: number
  error: boolean
  quoteType: string
  tags: QuoteTag[]
  disableRedirect?: boolean
}

export interface TaskRow {
  _id: string
  _rev: string
  title: string
  isAssigned: boolean
  isOwner: boolean
  startDateTime: Moment
  contactId?: string
  contactName: string
  contactEmail: string
  contactPreferred: string
  contactPhone: string
  companyName?: string
  companyId?: string
  owner: User
  updated: string
  completed: boolean
  dealName?: string
  dealId?: string
  dealAddress?: string
  notes?: string
  template?: {
    templateLabel: string
  }
}

export interface SelectableColumn {
  name: string
  field: string
  selected?: boolean
  sortable?: boolean
  minWidth?: number
  align?: 'left' | 'right' | 'center'
}

export interface ResultsTableColumnSelectProps {
  columns: SelectableColumn[]
  onConfirm: (columns: string[]) => void
  disabled?: boolean
}

export function ResultsTableColumnSelect(props: ResultsTableColumnSelectProps) {
  const { columns, onConfirm, disabled } = props
  const classes = useStyles(props)

  const [initialColumns] = useState<SelectableColumn[]>(columns)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  function handleConfirmClick() {
    const columns = values.map((column) => (column.checked ? column.value : null)).filter(Boolean)
    onConfirm(columns)
    setAnchorEl(null)
  }

  function handleCancelClick() {
    setAnchorEl(null)
    setValues(
      initialColumns.map((column) => {
        return {
          label: column.name,
          value: column.field,
          checked: column.selected
        }
      })
    )
  }

  const [values, setValues] = useState<DropdownSelectOption[]>(
    columns.map((column) => {
      return {
        label: column.name,
        value: column.field,
        checked: column.selected
      }
    })
  )

  function handleSubmit(ev) {
    ev.preventDefault()
  }

  function handleColumnChange(option: DropdownSelectOption) {
    setValues(
      values.map((value) => {
        if (value.value === option.value) {
          return {
            ...value,
            checked: !value.checked
          }
        }
        return value
      })
    )
  }

  return (
    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
      <FormControl>
        <IconButton
          size="small"
          onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}
          className={classes.button}
        >
          <ColumnsIcon />
          <ArrowDropDownIcon />
        </IconButton>

        <Popper
          open={!!anchorEl && !disabled}
          anchorEl={anchorEl}
          className={classes.popper}
          placement="bottom-end"
          modifiers={{
            flip: {
              enabled: false
            },
            preventOverflow: {
              enabled: false
            }
          }}
        >
          <form id="configure-columns-form" onSubmit={handleSubmit}>
            <Grid container className={classes.container}>
              {values.map((value) => {
                return (
                  <Grid key={value.value} item xs={12}>
                    <DropdownSelectMenuItem
                      option={value}
                      selected={value.checked}
                      showSelectableIcon
                      onClick={() => {
                        handleColumnChange(value)
                      }}
                    />
                  </Grid>
                )
              })}
            </Grid>
          </form>
          <DropdownSelectFooter onApply={handleConfirmClick} clearLabel="Cancel" onClear={handleCancelClick} />
        </Popper>
      </FormControl>
    </ClickAwayListener>
  )
}
